import React from 'react';
import { Brodcrumb } from '../../components/ui/UtilsLayout';
import { iconsPath, imagePath, videoPath } from '../../utils/imagePath';
import { BackgroundWithCurve, BulletSection, CaseStudiesImageCard, CaseStudyHeading, Section } from '../../utils/CaseStudiesComponents';

// CaseStudy Component
const GeoSpatial = () => {
  return (
    <div className="flex justify-center px-5 md:px-10 lg:px-16  items-center gap-6 text-white pb-16 relative">
      <BackgroundWithCurve />
      <div className="max-w-[1200px] w-full  pt-24 md:pt-32 relative z-10">
        {/* Breadcrumb Navigation */}
        <Brodcrumb
          data={{
            name: 'Space',
            item: [
              { name: 'Industry Use Cases', path: '/all-industries' },
              {
                name: 'Defence & Aerospace',
                path: '/industries/defence-aerospace',
              },
            ],
          }}
        />

        <div className="my-10 flex flex-col w-full gap-10">
          {/* Header Section with Logo */}
          <div className="flex gap-3 md:gap-5 lg:gap-10">
            <div className="flex justify-center items-center  bg-gradient-to-t from-[#474747] to-[#292929] shadow-[0px_0px_4px_1px_rgba(0,0,0,0.25)] h-20 w-20 md:h-20 md:w-20 lg:h-24 lg:w-24 rounded-lg">
              {/* Company Logo */}
              {imagePath?.SpaceLogo ? (
                <img
                  className="h-14 w-14 md:h-12 md:w-12 lg:h-16 lg:w-16 object-contain"
                  src={imagePath?.SpaceLogo}
                  alt="Space Logo"
                />
              ) : (
                <span className="text-gray-400 text-xs">No Logo</span>
              )}
            </div>

            {/* Case Study Heading */}
            <div className="flex flex-col gap-2 md:gap-5 justify-center">
              <CaseStudyHeading
                title="Space"
                desc="Geo Spatial - Disaster Management"
              />
            </div>
          </div>

          <div className="relative">
            {/* Video Container - Responsive aspect ratio */}
            <div className="relative w-full aspect-video bg-[#31333A] shadow-[0px_0px_21px_4px_rgba(0,0,0,0.25)] flex justify-center items-center ">
              {/* Play Icon */}
              {videoPath?.SpacedmVideo && (
                <video
                  src={videoPath?.SpacedmVideo}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full h-full object-cover rounded-lg"
                >
                  Your browser does not support the video tag.
                </video>
              )}

              {/* {iconsPath?.QRIcon && (
                <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 lg:-top-8 lg:-right-8 bg-[#fff] p-2 md:p-3 rounded-[10px]">
                  <img
                    src={iconsPath.QRIcon}
                    alt="QR Code"
                    className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24"
                  />
                </div>
              )} */}
            </div>
          </div>

          {/* Case Study Description */}
          <Section
            title="Simulating the Geospatial Map for Disaster Management"
            subtitle="Simulation of high risk weather conditions and its impact on urban areas"
            content="Understanding the topography helps plan the development of regions in a better and effective
            way as a result of which disasters can be managed efficiently saving lives of all natural beings.
            The objective of this project was to create a realistic 3D map of the location using the precise
            Satellite data to map out the slopes, heights and depths to help track path of floods. This will
            help alert the people living in the areas and move to safer locations."
          />

          <Section
            title="Execution"
            content={[
              'Spatial Grid platform was leveraged to develop the application by using the different plug-ins (like DEM files, 3D maps, Physics, particle effects, etc.) available. High-speed GPU based processors were used to simulate the different conditions in the application. External controls were interfaced to support the launch simulation. All the interaction data was stored to analyze for generating insights using Machine Learning (ML) methods.',
            ]}
          />
          <BulletSection
            introText="Components developed for this application are as follows:"
            bulletPoints={[
              'VR and MR based experience with scene animations',
              'Interfacing with external hardware-based systems',
              'Particle and Physics effects to simulate different conditions',
              'Interfacing with high-speed processors',
              'Overlaying realistic 3D maps on the geospatial data',
            ]}
            closingText="The project was developed and delivered in 4 weeks."
          />

          {/* Image Grid Section */}
          <div className="flex flex-col gap-3">
            <div className="flex md:flex-row flex-col gap-10 md:gap-20 w-full">
              <CaseStudiesImageCard
                image={imagePath?.SpaceDm1}
                title="Simulation"
              />
              <CaseStudiesImageCard
                image={imagePath?.SpaceDm2}
                title="Immersive Disaster Response Visualization"
              />
            </div>
          </div>

          {/* Impact Section */}
          <div className="flex flex-col gap-3">
            <Section
              title="Impact"
              content="This project facilitated the organization to build data sets for simulating to understand
the monitoring and management of floods. As this was executed leveraging VR and MR
technologies the organization was able to help save the budget significantly."
            />
          </div>
        </div>
      </div>
    </div>
  );
};
<CaseStudyHeading />;
<CaseStudiesImageCard />;

export default GeoSpatial;
